import Vue from 'vue'
import Router, { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(Router)

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/

export const constantRoutes: RouteConfig[] = [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    meta: { hidden: true, title: '登录 ' }
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    meta: { hidden: true }
  },

  {
    path: '/dashboard/sale',
    component: Layout,
    meta: { hidden: true, roles: [] },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/sale.vue'),
        meta: {
          title: '销售业绩'
        }
      }
    ]
  },
  {
    path: '/dashboard/audition',
    component: Layout,
    meta: { hidden: true, roles: [] },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/audition.vue'),
        meta: {
          title: '试听业绩'
        }
      }
    ]
  },
  {
    path: '/dashboard/order',
    component: Layout,
    meta: { hidden: true, roles: [] },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/order.vue'),
        meta: {
          title: '订单数据'
        }
      }
    ]
  },
  {
    path: '/dashboard/market',
    component: Layout,
    meta: { hidden: true, roles: [] },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/market.vue'),
        meta: {
          title: '市场数据'
        }
      }
    ]
  },
  {
    path: '/dashboard/customer',
    component: Layout,
    meta: { hidden: true, roles: [] },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/customer.vue'),
        meta: {
          title: '客服数据'
        }
      }
    ]
  },
  {
    path: '/dashboard/teacher',
    component: Layout,
    meta: { hidden: true, roles: [] },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/teacher.vue'),
        meta: {
          title: '教师数据'
        }
      }
    ]
  },
  {
    path: '/dashboard/teach-time',
    component: Layout,
    meta: { hidden: true, roles: [] },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/teachTime.vue'),
        meta: {
          title: '教师工作时长'
        }
      }
    ]
  },
  {
    path: '/dashboard/course-time',
    component: Layout,
    meta: { hidden: true, roles: [] },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/teachTime.vue'),
        meta: {
          title: '发布课程时长'
        }
      }
    ]
  },
  {
    path: '/dashboard-student',
    component: Layout,
    meta: { hidden: true, roles: [] },
    children: [
      {
        path: 'syks',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/student.vue'),
        meta: {
          title: '剩余课时小于五次'
        }
      },
      {
        path: 'xyzs',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/student.vue'),
        meta: {
          title: '新增学员总数'
        }
      },
      {
        path: 'xyksl',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/student.vue'),
        meta: {
          title: '学员累计新增课时'
        }
      }
    ]
  },
  {
    path: '/dashboard-course',
    component: Layout,
    meta: { hidden: true, roles: [] },
    children: [
      {
        path: 'fbkcsc',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/course.vue'),
        meta: {
          title: '发布课程时长'
        }
      },
      {
        path: 'jsgzsc',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/course.vue'),
        meta: {
          title: '教师工作时长'
        }
      },
      {
        path: 'xhxyks',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/course.vue'),
        meta: {
          title: '消耗学员课时'
        }
      },
      {
        path: 'xyskrs',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/course.vue'),
        meta: {
          title: '学员上课人数'
        }
      },
      {
        path: 'xydjfb',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/course.vue'),
        meta: {
          title: '学员等级分布'
        }
      },
      {
        path: 'gdjrs',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/course.vue'),
        meta: {
          title: '完成各等级人数'
        }
      },
      {
        path: 'gdjkc',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/course.vue'),
        meta: {
          title: '完成各等级课时'
        }
      }
    ]
  },
  {
    path: '/dashboard-business',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: 'khsl',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/business.vue'),
        meta: {
          title: '客户数量'
        }
      },
      {
        path: 'sjsl',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/business.vue'),
        meta: {
          title: '商机数量'
        }
      },
      {
        path: 'stsjsl',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/business.vue'),
        meta: {
          title: '试听商机数量'
        }
      },
      {
        path: 'stsjcj',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/business.vue'),
        meta: {
          title: '试听商机成交量'
        }
      },
      {
        path: 'stsjcje',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/business.vue'),
        meta: {
          title: '试听商机成交额',
          roles: []
        }
      },
      {
        path: 'stsjjcje',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/business.vue'),
        meta: {
          title: '试听商机均成交额',
          roles: []
        }
      },
      {
        path: 'xszl',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/business.vue'),
        meta: {
          title: '销售总量',
          roles: []
        }
      },
      {
        path: 'xscjl',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/business.vue'),
        meta: {
          title: '销售成交量',
          roles: []
        }
      },
      {
        path: 'xscje',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/business.vue'),
        meta: {
          title: '销售成交额',
          roles: []
        }
      },
      {
        path: 'xszcje',
        component: () => import(/* webpackChunkName: "form" */ '@/views/dashboard/business.vue'),
        meta: {
          title: '销售总成交额',
          roles: []
        }
      }

    ]
  },
  {
    path: '/customer/student/detail',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/management/student-detail.vue'),
        meta: {
          title: '学员详情'
        }
      }
    ]
  },
  {
    path: '/order/detail',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/order/details.vue'),
        meta: {
          title: '订单详情'
        }
      }
    ]
  },
  {
    path: '/map',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/campus/map.vue'),
        meta: {
          title: '客户分布图'
        }
      }
    ]
  },
  {
    path: '/campus/detail',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/campus/detail.vue'),
        meta: {
          title: '校区详情'
        }
      }
    ]
  },
  {
    path: '/employee/detail',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "form" */ '@/views/employee/detail.vue'),
        meta: {
          title: '员工详情'
        }
      }
    ]
  }
]

export const asyncRoutes: RouteConfig[] = [
  {
    path: '',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
        meta: {
          title: '首页',
          icon: 'home',
          affix: true,
          roles: []
        }
      }
    ]
  },
  {
    path: '/course',
    component: Layout,
    meta: {
      title: '课程中心',
      icon: 'course-center',
      breadcrumb: false,
      roles: []
    },
    children: [
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/course/table.vue'),
        meta: {
          title: '课程表',
          roles: []
        }
      },
      {
        path: 'sign',
        component: () => import(/* webpackChunkName: "table" */ '@/views/course/sign.vue'),
        meta: {
          title: '正式课签到记录',
          roles: []
        }
      },
      {
        path: 'audition',
        component: () => import(/* webpackChunkName: "table" */ '@/views/course/audition.vue'),
        meta: {
          title: '试听课签到记录',
          roles: []
        }
      },
    ]
  },
  {
    path: '/customer',
    component: Layout,
    meta: {
      title: '客户中心',
      icon: 'customer-center',
      breadcrumb: false,
      roles: []
    },
    children: [
      {
        path: 'student',
        component: () => import(/* webpackChunkName: "table" */ '@/views/management/student.vue'),
        meta: {
          title: '学员管理',
          affix: true,
          roles: []
        }
      },
      {
        path: 'business',
        component: () => import(/* webpackChunkName: "table" */ '@/views/management/business.vue'),
        meta: {
          title: '商机管理',
          affix: true,
          roles: []
        }
      },
      {
        path: 'list',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/management/customer.vue'),
        meta: {
          title: '客户管理',
          affix: true,
          roles: []
        }
      },
      {
        path: 'clue',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/management/clue.vue'),
        meta: {
          title: '线索池',
          affix: true,
          roles: []
        }
      },
      {
        path: 'order',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/order/index.vue'),
        meta: {
          title: '订单管理',
          affix: true,
          roles: []
        }
      }
    ]
  },
  {
    path: '/employee',
    component: Layout,
    meta: {
      title: '人员管理',
      icon: 'people',
      breadcrumb: false,
      roles: []
    },
    children: [
      {
        path: 'ranking',
        component: () => import(/* webpackChunkName: "table" */ '@/views/employee/ranking.vue'),
        meta: { title: '人员数据排名',
          roles: [] }
      },
      {
        path: 'list',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/employee/list.vue'),
        meta: {
          title: '人员管理',
          affix: true,
          roles: []
        }
      },
      {
        path: 'role',
        component: () => import(/* webpackChunkName: "table" */ '@/views/employee/role.vue'),
        meta: { title: '角色管理',
          roles: [] }
      }
    ]
  },
  {
    path: '/goods',
    component: Layout,
    meta: {
      title: '物品管理',
      icon: 'goods',
      breadcrumb: false,
      roles: []
    },
    children: [
      {
        path: 'sell',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/goods/sell.vue'),
        meta: {
          title: '出售物品管理',
          affix: true,
          roles: []
        }
      },
      {
        path: 'serve',
        component: () => import(/* webpackChunkName: "table" */ '@/views/goods/serve.vue'),
        meta: { title: '服役物品管理',
          roles: [] }
      },
      {
        path: 'storage',
        component: () => import(/* webpackChunkName: "table" */ '@/views/goods/storage.vue'),
        meta: { title: '仓储物品管理',
          roles: [] }
      }
    ]
  },
  {
    path: '/platform',
    component: Layout,
    meta: {
      title: '平台管理',
      icon: 'platform',
      breadcrumb: false,
      roles: []
    },
    children: [
      {
        path: 'campus',
        component: () => import(/* webpackChunkName: "table" */ '@/views/campus/index.vue'),
        meta: { title: '校区管理',
          roles: [] }
      },
      {
        path: 'loges',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/platform/loges.vue'),
        meta: {
          title: '日志管理',
          affix: true,
          roles: []
        }
      },
      {
        path: 'message',
        component: () => import(/* webpackChunkName: "table" */ '@/views/platform/message.vue'),
        meta: { title: '短信管理',
          roles: [] }
      },
      {
        path: 'feedback',
        component: () => import(/* webpackChunkName: "table" */ '@/views/platform/feedback.vue'),
        meta: { title: '问题反馈',
          roles: [] }
      }
    ]
  },
  {
    path: '/teaching',
    component: Layout,
    meta: {
      title: '教学管理',
      icon: 'teaching',
      breadcrumb: false,
      roles: []
    },
    children: [
      {
        path: 'essential',
        component: () => import(/* webpackChunkName: "table" */ '@/views/site/essential.vue'),
        meta: { title: '教学要点设置', roles: [] }
      },
      {
        path: 'subject',
        component: () => import(/* webpackChunkName: "table" */ '@/views/course/subject.vue'),
        meta: {
          title: '教学主题设置',
          roles: []
        }
      },
      {
        path: 'material',
        component: () => import(/* webpackChunkName: "table" */ '@/views/site/material.vue'),
        meta: { title: '教学素材设置', roles: [] }
      }
    ]
  },
  {
    path: '/course-set',
    component: Layout,
    meta: {
      title: '课程设置',
      icon: 'course-set',
      breadcrumb: false,
      roles: []
    },
    children: [
      {
        path: 'type',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/site/type.vue'),
        meta: { title: '课程种类设置', roles: [] }
      },
      {
        path: 'level',
        component: () => import(/* webpackChunkName: "table" */ '@/views/site/level.vue'),
        meta: { title: '课程等级设置', roles: [] }
      },
      {
        path: 'difficulty',
        component: () => import(/* webpackChunkName: "table" */ '@/views/site/difficulty.vue'),
        meta: { title: '主题等级设置', roles: [] }
      },
      {
        path: 'packet',
        component: () => import(/* webpackChunkName: "table" */ '@/views/course/packet.vue'),
        meta: {
          title: '课程套餐管理',
          roles: []
        }
      },
      {
        path: 'curriculum',
        component: () => import(/* webpackChunkName: "table" */ '@/views/course/curriculum.vue'),
        meta: {
          title: '课程列表管理',
          roles: []
        }
      }
    ]
  },
  {
    path: '/other-set',
    component: Layout,
    meta: {
      title: '基础设置',
      icon: 'basis-set',
      breadcrumb: false,
      roles: []
    },
    children: [
      {
        path: 'instrument',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/other/instrument.vue'),
        meta: { title: '乐器类型设置', roles: [] }
      },
      {
        path: 'student',
        component: () => import(/* webpackChunkName: "table" */ '@/views/other/student.vue'),
        meta: { title: '学员等级设置', roles: [] }
      },
      {
        path: 'customer',
        component: () => import(/* webpackChunkName: "table" */ '@/views/other/customer.vue'),
        meta: { title: '客户来源设置', roles: [] }
      },
      {
        path: 'teacher',
        component: () => import(/* webpackChunkName: "table" */ '@/views/other/teacher.vue'),
        meta: { title: '教师等级设置', roles: [] }
      },
      {
        path: 'goods',
        component: () => import(/* webpackChunkName: "table" */ '@/views/other/goods.vue'),
        meta: { title: '物品类型设置', roles: [] }
      }
    ]
  },
  {
    path: '/applet',
    component: Layout,
    meta: {
      title: '学生端设置',
      icon: 'student',
      breadcrumb: false,
      roles: []
    },
    children: [
      {
        path: 'banner',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/applet/banner.vue'),
        meta: { title: '轮播图设置', roles: [] }
      },
      {
        path: 'article',
        component: () => import(/* webpackChunkName: "table" */ '@/views/applet/article.vue'),
        meta: { title: '文章设置', roles: [] }
      },
      {
        path: 'agreement',
        component: () => import(/* webpackChunkName: "table" */ '@/views/applet/agreement.vue'),
        meta: { title: '帮助设置', roles: [] }
      },
      {
        path: 'about',
        component: () => import(/* webpackChunkName: "table" */ '@/views/applet/about.vue'),
        meta: { title: '关于我们设置', roles: [] }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    meta: { hidden: true }
  }
]

const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  (router as any).matcher = (newRouter as any).matcher // reset router
}
export default router
